<button class="left1"  mat-raised-button   (click)="btnClick(user_Id);">
    <span class="style">Add Working Days</span>
</button>
<!---------------------------------new ui---------------------------------------------------->

    <section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>User Working Days</h1>
    </div>
    </div>
  
    </section>
<!--------------loader-------------------------->
<div *ngIf=loaderShown class="loader"></div>
<!----------------------------------------------->
    
    <section class="content">
    
    <div class="card" *ngIf=cardShown>
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <!-- <th style="width: 20%">
     Department Name
    </th> -->

    <th style="width: 30%">
   Month
    </th>


    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <!-- <td>
    <a>
     {{c._id}} 
    </a>
    </td> -->
    
    <td>
    {{formatDate(c.month_year)}} 
    </td>


    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm"  (click)='Details(c._id)'>  
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='EditDetails(c._id)'>  
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    
    <a class="btn btn-danger btn-sm left"  data-toggle="modal" data-target="#modal-sm" (click)="SetAttendence(c._id)"> 
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!------------------------------------------------------------>
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Are you sure to delete "{{ListName}}"?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeleteList();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>
<!---------------------paging------------------------------------->
<!-- <ul class="pagination" *ngIf=cardShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
  -->

